interface CarouselDot {
  index: number;
  size: 'active' | 'normal' | 'small';
}

export const useCarouselWindow = (count: Ref<number>, selected: Ref<number>, windowSize = 7) =>
  computed<CarouselDot[]>(() => {
    const total = count.value;
    if (total <= windowSize) return buildDots(total, selected.value, 0, total);
    const half = Math.floor(windowSize / 2);
    const start = Math.max(0, Math.min(selected.value - half, total - windowSize));
    return buildDots(total, selected.value, start, start + windowSize);
  });

function buildDots(total: number, active: number, start: number, end: number): CarouselDot[] {
  const dots: CarouselDot[] = [];
  for (let index = start; index < end; index++) {
    dots.push({ index, size: dotSize(index, active, total, start, end) });
  }
  return dots;
}

function dotSize(index: number, active: number, total: number, start: number, end: number): CarouselDot['size'] {
  if (index === active) return 'active';
  const isEdge = (index === start && start > 0) || (index === end - 1 && end < total);
  return isEdge ? 'small' : 'normal';
}
